import React from 'react';

/**
 * Card shown while the user is waiting in the live-agent queue.
 * @param {string} waitTime - Estimated wait time text (e.g. "2 minutes").
 * @param {() => void} onExit - Called when the user clicks "Exit queue".
 * @param {boolean} [exiting] - True while waiting for the backend to ack the exit.
 */
function QueueCard({ waitTime, onExit, exiting }) {
  return (
    <div className="queue-card">
      <div className="queue-card-title">We'll alert you when an agent enters the chat.</div>
      <div className="queue-card-text">Please turn your volume up.</div>
      {waitTime && (
        <div className="queue-card-text">Estimated wait time: {waitTime}</div>
      )}
      <button type="button" className="queue-card-exit-btn" onClick={onExit} disabled={exiting}>
        {exiting ? 'Exiting queue…' : 'Exit queue'}
      </button>
    </div>
  );
}

export default QueueCard;
